import { Lightning } from '@lightningjs/sdk'

import { Router } from '@lightningjs/sdk'
import { getColor, grey50, grey700, grey960, primary500 } from '../../constants/colors'
import { UniNeueBold } from '../../constants/fonts'
import { BORDER_RADIUS } from '../../constants/general'
import { BASE_ROUTES } from '../../constants/routes'
import { TvButtonModel } from '../../types/flo-experience'
import { getIcon } from '../../utils/image'
import { captureClick, SEGMENT_TRACK_EVENTS } from '../../utils/segmentAnalytics'
import SpeechComp from '../speechComp/speechComp'

const ICON_SIZE = 32

export default class EditFavoritesButton extends SpeechComp {
  private _data: TvButtonModel
  private _rowIndex = 0

  static _template() {
    return {
      w: 328,
      h: 120,
      rect: true,
      clipping: true,
      collision: true,
      color: getColor(primary500),
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        radius: BORDER_RADIUS,
      },
      Fill: {
        x: -1,
        y: -1,
        w: (w) => w + 2,
        h: (h) => h + 2,
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: BORDER_RADIUS,
          fillColor: getColor(grey700),
        },
      },
      ContentWrapper: {
        w: (w) => w,
        h: (h) => h,
        flex: {
          direction: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        },
        Icon: {
          w: 36,
          h: 36,
          flexItem: { marginRight: 24 },
          color: getColor(grey50),
          texture: null,
        },
        Label: {
          text: {
            text: '',
            textColor: getColor(grey50),
            fontSize: 32,
            fontFace: UniNeueBold,
            lineHeight: 32,
            verticalAlign: 'middle',
          },
        },
      },
    }
  }

  get contentWrapper() {
    return this.tag('ContentWrapper')
  }

  get fill() {
    return this.tag('Fill')
  }

  get label() {
    return this.tag('Label')
  }

  get icon() {
    return this.tag('Icon')
  }

  set data(v: TvButtonModel) {
    this._data = v
  }

  get data() {
    return this._data
  }

  set rowIndex(v) {
    this._rowIndex = v
  }

  get rowIndex() {
    return this._rowIndex
  }

  get speechText(): string {
    return this.data?.title?.text
  }

  _init() {
    this.renderButtonData()
  }

  _handleEnter() {
    void captureClick(SEGMENT_TRACK_EVENTS.ButtonClicked, this.data?.action?.analytics)
    Router.navigate(BASE_ROUTES.EDIT_FAVORITES)
  }

  _focus() {
    this.fill.patch({
      x: 6,
      w: (w) => w - 5,
      shader: { fillColor: getColor(grey50) },
    })
    this.contentWrapper.patch({
      Icon: {
        color: getColor(grey960),
      },
      Label: {
        text: {
          textColor: getColor(grey960),
        },
      },
    })
    this.speak()
  }

  _unfocus() {
    this.fill.patch({
      x: -1,
      w: (w) => w + 2,
      shader: { fillColor: getColor(grey700) },
    })
    this.contentWrapper.patch({
      Icon: {
        color: getColor(grey50),
      },
      Label: {
        text: {
          textColor: getColor(grey50),
        },
      },
    })
  }

  renderButtonData() {
    this.contentWrapper.patch({
      Icon: {
        texture: Lightning.Tools.getSvgTexture(
          getIcon(this.data?.icon?.style),
          ICON_SIZE,
          ICON_SIZE,
        ),
      },
      Label: {
        text: {
          text: this.data?.title?.text ?? '',
        },
      },
    })
  }

  _handleHover() {
    this.fireAncestors('$updateFocusByHover', this)
    this._focus()
  }

  _handleUnhover() {
    this._unfocus()
  }

  _handleClick() {
    this._handleEnter()
  }
}
